import Redirect from './Redirect'

const homepageUrl = '/'
const NotFound = () => <Redirect url={homepageUrl} placeholder={homepageUrl} />

export default NotFound
